import { mapActions, mapGetters } from "vuex";
export default {
    props: ["cartItem"],
    computed: {
        ...mapGetters(["rate"]),
        subtotal() {
            return this.cartItem.count * this.cartItem.price;
        },
        itemPhoto() {
            if (this.cartItem.images.length)
                return this.cartItem.images[0].fileNameUrl;
            else return "sin_foto.jpg";
        },
        itemPriceUSD() {
            if (this.rate) return this.cartItem.price / this.rate;
            else return "";
        },
        subtotalPriceUSD() {
            if (this.rate) return this.subtotal / this.rate;
            else return "";
        }
    },
    methods: {
        ...mapActions(["updateCart", "removeItemInCart"]),
        removeItem() {
            let vm = this;
            this.removeItemInCart({
                item: vm.cartItem
            });
        },
    }
};
